import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.find.js";
import { FIB } from '@/config/constants';
var VOUCHER_SUBPURPOSE = FIB.VOUCHER_SUBPURPOSE; // Determines if a voucher which a chance associated with it should be selected or not

function chanceBasedVoucherPasses(v) {
  if (!(v !== null && v !== void 0 && v.chance)) {
    return false;
  }

  var probability = 1 / v.chance;
  return Math.random() < probability;
} // Select which voucher to use from at least one


function selectFromAtLeastOne(vouchers, incentive) {
  // We must have at least 1 voucher to have gotten to this point.
  // If there's only 0-1 voucher to choose from (necessarily an incentive voucher, by the rule above), we're done.
  if (vouchers.length <= 1) {
    return incentive;
  } // Else there's more than 1 voucher to choose from - an incentive or an instant win.


  var instantWin = vouchers.find(function (v) {
    return v.type === VOUCHER_SUBPURPOSE.VOUCHER_SUBPURPOSE_INSTANT_WIN;
  });
  return chanceBasedVoucherPasses(instantWin) ? instantWin : incentive;
}

export default {
  /**
   * Perform voucher selection, returning either the selected voucher, or null if none has been selected.
   * @param {Array} vouchers
   * @returns {Object|Null}
   */
  select: function select(vouchers) {
    // A strange rule which is inherited from legacy guest (which we've decided to keep), is that
    // if there's not some incentive voucher, we want to select no voucher.
    var incentive = vouchers.find(function (v) {
      return v.type === VOUCHER_SUBPURPOSE.VOUCHER_SUBPURPOSE_INCENTIVE;
    });

    if (!incentive) {
      return null;
    } // We now know we have at least one voucher to select from..


    var selected = selectFromAtLeastOne(vouchers, incentive);
    return _objectSpread(_objectSpread({}, selected), {}, {
      // If there's only 1 voucher which could have been won, we'll want it to be already scratched, else
      // add some mystery and don't scratch it.
      scratched: vouchers.length <= 1
    });
  }
};